// extracted by mini-css-extract-plugin
export var embeddedCta = "style-module--embedded-cta--79ecd";